import React, {useContext} from "react";
import columns from "./columns";
import {ProviderContext} from "../ProviderContext";
import {ProviderOrderContext} from "./ProviderOrdersContext.jsx";
import "./provider-orders.css";
import {TableDateRangeTable} from "../../components/OrdersDateRangeTable/TableDateRangeTable.jsx";
import {OrdersShortcuts} from "../../event/consts.js";

export const ProviderOrders = () => {
    const {providerDetails} = useContext(ProviderContext);

    const {onDetails, acceptOffer, orders, eventsQueue, setSearchInput, loadingOrders, onDelivered} =
        useContext(ProviderOrderContext);

    return (
        <div className="provider-orders">
            <div className="provider-manage-invoices-title">ניהול הזמנות</div>
            <div className="provider-orders-sub-title">
                לחצו על כפתור ֿ״צפייה בהזמנה״ על מנת לעבור על פרטי ההזמנה ולאשרה
            </div>

            <TableDateRangeTable
                tableClassName="provider-order-table"
                data={orders}
                isLoadingOrderTable={loadingOrders}
                shortcutSearchOptions={OrdersShortcuts}
                onInputSearch={setSearchInput}
                columns={columns(providerDetails, onDetails, onDelivered, acceptOffer, eventsQueue)}
            />
        </div>
    );
};
